import { createContext } from 'react'

export const defaultContext = {
    isMagicWindow: false,
    isMobile: false,
    ikeaNav: true,
    allowShare: true,
    hideDashboard: false,
    isKiosk: false,
}

const SugarcubeContext = createContext(defaultContext)

export default SugarcubeContext
